export default __webpack_public_path__ + "static/media/21-min.87387221.png";